import React, { useEffect, useState } from 'react'
import CheckOptionSelections from './CheckOptionSelections'
import Select from 'react-select'
import { CButton, CFormLabel } from '@coreui/react'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import SaveExtra from '../../services/general/saveExtraData.api'

const typeOptions = [
  // { value: 'accordion', label: 'Accordion' },
  { value: 'header', label: 'Header' },
  { value: 'subHeader', label: 'Sub Header' },
  { value: 'option', label: 'Option' },
  // { value: 'subHeader', label: 'Input' }
]
const PECopyDescription = ({ childID, parentID, handleSave, apiType = 'PhysicalExaminationDummyData', setGeneralExaminationData, setActiveTab, setDescriptionText }) => {
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [generalOptions, setGeneralOptions] = useState([])
  const [selectedGeneralExamination, setSelectedGeneralExamination] = useState([])
  const [selectedType, setSelectedType] = useState(null)
  const [dataOptions, setDataOptions] = useState([])
  const [selectedData, setSelectedData] = useState([])
  const [finalSelectedData, setFinalSelectedData] = useState([])
  const [selectedHeaderOption, setSelectedHeaderOption] = useState([])
  const [selectedHeader, setSelectedHeader] = useState([])
  const [selectSubHeader, setSelectSubHeader] = useState([])
  const [subHeaderOption, setSubHeaderOption] = useState([])
  const [descriptionData, setDescriptionData] = useState([])

  const getGeneralExaminationData = async () => {
    setIsPageLoading(false)
    try {
      let data = await SaveExtra('Get_By_Type', apiType, '', '')
      data = JSON.parse(data.d)?.Data || []

      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }

      setGeneralOptions(
        data[0]?.Data.map((item) => {
          return {
            ...item,
            value: item.id,
            label: item.name,
          }
        }),
      )
      // setExaminationData(data);
      // setGeneralExaminationData(data[0]?.Data)
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const extractHierarchyData = (hierarchy, selectedType) => {
    return hierarchy.flatMap((item) => {
      let extractedData = []

      if (selectedType == item.type) {
        extractedData.push({
          ...item,
          value: item.id,
          label: item.name,
        })
      }

      if (item.hierarchy && Array.isArray(item.hierarchy)) {
        extractedData = [...extractedData, ...extractHierarchyData(item.hierarchy, selectedType)]
      }

      return extractedData
    })
  }
  const handleCopyDescription = (parentID, description) => {
    const updateData = (data) => {
      return data.map((item) => {
        if (item.id === parentID) {
          setDescriptionText(item.alert !== '' ? `${item.alert},${description}` : description)
          return {
            ...item,
            alert: item.alert !== '' ? `${item.alert},${description}` : description,
          }
        } else if (item.isHierarchy && Array.isArray(item.hierarchy)) {
          return { ...item, hierarchy: updateData(item.hierarchy) }
        }
        return item
      })
    }
    toast.success('Description Copied', toastConfig)
    setGeneralExaminationData((prevData) => updateData(prevData))
    setActiveTab(0)
  }

  useEffect(() => {
    if (selectedType && (selectedType?.value === 'header' || selectedType?.value == 'subHeader')) {
      let fetchSelectedData = selectedGeneralExamination?.flatMap((exam) => extractHierarchyData(exam.hierarchy || [], selectedType.value)) || []
      let uniqueData = Array.from(new Map(fetchSelectedData.map((item) => [item.label, item])).values())

      setDataOptions(uniqueData)
    } else if (selectedType && selectedType?.value === 'option') {
      let fetchHeaderData = selectedGeneralExamination?.flatMap((exam) => extractHierarchyData(exam.hierarchy || [], 'header')) || []

      let headerData = Array.from(new Map(fetchHeaderData.map((item) => [item.label, item])).values())

      //   sub Header
      let fetchSubHeader = headerData?.flatMap((exam) => extractHierarchyData(exam.hierarchy || [], 'subHeader')) || []

      let uniqueSubHeaderData = Array.from(new Map(fetchSubHeader.map((item) => [item.label, item])).values())

      // option data
      let fetchSelectedData = selectedGeneralExamination?.flatMap((exam) => extractHierarchyData(exam.hierarchy || [], 'option')) || []

      let uniqueData = Array.from(new Map(fetchSelectedData.map((item) => [item.label, item])).values())
      setSelectedHeaderOption(headerData)
      setDataOptions(uniqueData)
      setSubHeaderOption(uniqueSubHeaderData)
    }
  }, [selectedType, selectedGeneralExamination])

  useEffect(() => {
    if (selectedHeader.length > 0) {
      let fetchSubHeader = selectedHeader?.flatMap((exam) => extractHierarchyData(exam.hierarchy || [], 'subHeader')) || []

      let uniqueSubHeaderData = Array.from(new Map(fetchSubHeader.map((item) => [item.label, item])).values())
      // options
      let fetchSelectedData = selectedHeader?.flatMap((exam) => extractHierarchyData(exam.hierarchy || [], 'option')) || []

      let uniqueData = Array.from(new Map(fetchSelectedData.map((item) => [item.label, item])).values())
      setDataOptions(uniqueData)
      setSubHeaderOption(uniqueSubHeaderData)
    } else if (selectedHeader.length === 0) {
      let fetchSelectedData = selectedGeneralExamination?.flatMap((exam) => extractHierarchyData(exam.hierarchy || [], 'option')) || []

      let uniqueData = Array.from(new Map(fetchSelectedData.map((item) => [item.label, item])).values())
      setDataOptions(uniqueData)
      setSubHeaderOption([])
    }
  }, [selectedHeader])

  useEffect(() => {
    if (selectSubHeader.length > 0) {
      let fetchSelectedData = selectSubHeader?.flatMap((exam) => extractHierarchyData(exam.hierarchy || [], 'option')) || []

      let uniqueData = Array.from(new Map(fetchSelectedData.map((item) => [item.label, item])).values())
      setDataOptions(uniqueData)
    } else if (selectSubHeader.length === 0) {
      let fetchSelectedData = selectedGeneralExamination?.flatMap((exam) => extractHierarchyData(exam.hierarchy || [], 'option')) || []
      let uniqueData = Array.from(new Map(fetchSelectedData.map((item) => [item.label, item])).values())
      setDataOptions(uniqueData)
    }
  }, [selectSubHeader])
  useEffect(() => {
    getGeneralExaminationData()
  }, [])

  return (
    <>
      <div className="mx-5 mt-2 ">
        <div className=" p-1 " style={{ borderRadius: '10px', height: '450px', overflow: 'auto' }}>
          <CheckOptionSelections options={generalOptions || []} selectedValue={selectedGeneralExamination} setSelectedValue={setSelectedGeneralExamination} isPageLoading={isPageLoading} Label={'Select General Examination'} />
          {/* <CheckOptionSelections
                            options={typeOptions || []}
                            selectedValue={selectedType}
                            setSelectedValue={setSelectedType}
                            isPageLoading={isPageLoading}
                            Label={'Select Type'}
                        /> */}
          <div>
            <CFormLabel style={{ fontSize: '16px', fontWeight: '500' }}>Select Type</CFormLabel>
            <Select className="basic-single-select ui-react-select" classNamePrefix="select" options={typeOptions || []} value={selectedType} onChange={setSelectedType} isPageLoading={isPageLoading} />
          </div>

          {selectedType && (selectedType?.value === 'header' || selectedType?.value === 'subHeader') && (
            <div className="mt-2">
              <CheckOptionSelections options={dataOptions || []} selectedValue={selectedData} setSelectedValue={setSelectedData} isPageLoading={isPageLoading} Label={`Select ${selectedType.label}`} />
              <CheckOptionSelections options={selectedData.map((item) => ({ value: item.id, label: item.alert })).filter((item) => item.label) || []} selectedValue={descriptionData} setSelectedValue={setDescriptionData} isPageLoading={isPageLoading} Label={'Select Description'} />
            </div>
          )}
          {selectedType && selectedType?.value === 'option' && (
            <div className="mt-2">
              <CheckOptionSelections options={selectedHeaderOption || []} selectedValue={selectedHeader} setSelectedValue={setSelectedHeader} isPageLoading={isPageLoading} Label={'Select Header'} />
              <CheckOptionSelections options={subHeaderOption || []} selectedValue={selectSubHeader} setSelectedValue={setSelectSubHeader} isPageLoading={isPageLoading} Label={'Select Sub Header'} />
              <CheckOptionSelections options={dataOptions || []} selectedValue={selectedData} setSelectedValue={setSelectedData} isPageLoading={isPageLoading} Label={'Select Option'} />
              <CheckOptionSelections options={selectedData.map((item) => ({ value: item.id, label: item.alert })).filter((item) => !item.label) || []} selectedValue={descriptionData} setSelectedValue={setDescriptionData} isPageLoading={isPageLoading} Label={'Select Description'} />
            </div>
          )}
        </div>
        <div className="text-end">
          <CButton variant="outline" onClick={() => handleCopyDescription(parentID, descriptionData.map((item) => item.label).join(', '))} className="px-4">
            Add
          </CButton>
        </div>
      </div>
    </>
  )
}

export default PECopyDescription
